import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import { notebookNotesSuccess, notebookNoteSuccess, shiftNotesSuccess } from './actions';

import initialState from './states';

export default handleActions(
  {
    [logoutSuccess]() {
      return initialState;
    },
    [notebookNoteSuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.notebookNoteID]: payload,
        },
      };
    },
    [notebookNotesSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [shiftNotesSuccess](state, { payload: item }) {
      return {
        ...state,
        notes: {
          ...state.notes,
          [item.shiftID]: item,
        },
      };
    },
  },
  initialState
);
